import React from 'react'
import { Heading } from '@pandiafi/design-system'

interface CardTitleBandProps {
  children: React.ReactNode
}

export const CardTitleBand: React.FC<CardTitleBandProps> = ({ children }) => (
  <div className="bg-brand-1 py-8 mb-10 text-center rounded-lg min-tablet:rounded-b-none min-tablet:-mt-6 min-tablet:-mx-6 desktop:-mt-7 desktop:-mx-7">
    <Heading size="l" element="h2">
      {children}
    </Heading>
  </div>
)
